import { Injectable } from "@angular/core";
import { AccountUserDTO } from "../accounts/AccountUser";
import { ApiService } from "../api.service";

const PATH = "account-users";

@Injectable({
  providedIn: "root",
})
export class AccountUsersHandlerService {
  constructor(private APIService: ApiService) {}

  getAccountUsers(masterAccountID: number) {
    return this.APIService.get(`${PATH}/${masterAccountID}`);
  }

  putAccountUser(
    masterAccountID: number,
    accountUserID: number,
    accountUserDTO: AccountUserDTO,
  ) {
    return this.APIService.put(
      `${PATH}/${masterAccountID}/${accountUserID}`,
      accountUserDTO,
    );
  }

  postAccountUser(masterAccountID: number, accountUserDTO: AccountUserDTO) {
    return this.APIService.post(`${PATH}/${masterAccountID}`, accountUserDTO);
  }

  deleteAccountUser(masterAccountID: number, accountUserID: number) {
    return this.APIService.delete(
      `${PATH}/${masterAccountID}/${accountUserID}`,
    );
  }
}
